import React from "react";

export const Admin = () => {
    return (
        <div>
            <h1>Администрирование</h1>
        </div>
    );
};

export default Admin;